import AgentAccountMenu from '../../../molecules/menus/AgentAccountMenu';

const AccountMenu = () => {
  return <AgentAccountMenu />;
};

export default AccountMenu;
